export const styles = {
  container: 'flex-1 flex flex-col justify-between px-4 py-6',
  buttonsContainer: 'space-y-6 flex flex-col justify-start pt-6 flex-1',
  button:
    'px-4 py-2 font-semibold cursor-pointer focus:outline-none transition-colors duration-150 bg-primary-pure hover:bg-stone-800 border border-primary-pure disabled:bg-gray-300 disabled:text-gray-500 disabled:border-gray-300 disabled:cursor-not-allowed h-[55px] w-full rounded-[10px] text-xl font-semibold',
  blackButton:
    'px-4 py-2 font-semibold cursor-pointer focus:outline-none transition-colors duration-150 bg-primary-pure hover:bg-stone-800 border border-primary-pure disabled:bg-gray-300 disabled:text-gray-500 disabled:border-gray-300 disabled:cursor-not-allowed h-[55px] w-full rounded-[10px] text-xl font-semibold',
  finishButton:
    'px-4 py-2 font-semibold cursor-pointer focus:outline-none transition-colors duration-150 bg-primary-pure text-white hover:bg-stone-800 border border-primary-pure disabled:bg-gray-300 disabled:text-gray-500 disabled:border-gray-300 disabled:cursor-not-allowed h-[55px] w-full rounded-[10px] text-xl font-semibold',
} as const

export const texts = {
  startSale: 'Iniciar venta',
  dailySales: 'Ventas del día',
  previousClosings: 'Cierres anteriores',
  finishDay: 'Finalizar jornada',
} as const
